<template>
  <ThreeDButton
    class="confirm-choice-button"
    @click="$emit('click')"
    :title="$t('buttons.save')"
    :disabled="disabled"
  >
    <FaIcon v-if="!disabled" icon="check" />
    <FaIcon v-else icon="lock-alt" />
  </ThreeDButton>
</template>

<script>
import FaIcon from '../../ui/FaIcon'
import ThreeDButton from '../../ThreeDButton'

export default {
  name: 'ConfirmChoiceButton',
  components: { ThreeDButton, FaIcon },
  props: {
    disabled: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.three-d-button {
  --button-border-radius: 4em;
  --button-color: #{$successText};
  --button-shadow-color: #{darken($successText, 20%)};

  width: 4em;
  height: 4em;
  padding: 0;
}
</style>
